import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import {
  renderMultiLineTextField,
  renderSelectField6,
  renderTextField,
} from '../../form-global-components/components-form-components-for-react-final-form';
import {
  NO_YES,
} from '../../../actions/action-constants';
class FormFieldsClientsTabsTabVoluntaryProgramActivity extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
              
                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NO_YES}
                      id='clientcommunityvolunteerprojects'
                      name='clientcommunityvolunteerprojects'
                      label='Client Community Volunteer Projects'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={12} >
                      <Field
                        locked={this.props.locked}
                        component={renderTextField}
                        id='clientcommunityvolunteerprojectscompleted'
                        name='clientcommunityvolunteerprojectscompleted'
                        label='Client Community Volunteer Projects Completed'
                      />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NO_YES}
                      id='clientaana'
                      name='clientaana'
                      label='Client AA / NA'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NO_YES}
                      id='clientfaithbased' 
                      name='clientfaithbased'
                      label='Client Crosspoint Faith-Based Activities'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>  
                  <Grid item xs={12} >
                    <Field
                      autoFocus
                      component={renderSelectField6}
                      locked={this.props.locked}
                      dataArray={NO_YES}
                      id='clientadulteducation' 
                      name='clientadulteducation'
                      label='Client Adult Education Activities During Stay'
                      footerMessage=''
                    />
                  </Grid>
                </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientadulteducationcomments'
                    name='clientadulteducationcomments'
                    label='Client Adult Education Activities During Stay Comments'
                    rows='6'
                    emptyText='Degree or Certificates'
                    footerMessage='Degree or Certificates'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientcompletedadulteducation'
                    name='clientcompletedadulteducation'
                    label='Client Completed An Education Activity During Stay'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientrecoverycoachengagement'
                    name='clientrecoverycoachengagement'
                    label='Client Recovery Coach Engagement'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientmedicationassistedtherapy' 
                    name='clientmedicationassistedtherapy'
                    label='Client Medication Assisted Therapy'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsClientsTabsTabVoluntaryProgramActivity.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsClientsTabsTabVoluntaryProgramActivity;